import styled from 'styled-components'
import { ControlSize } from 'types/src/controls'
import { borderRadiusFromControlSize } from 'utils/src/control-size'

export const Wrapper = styled.div`
    align-items: center;
    border-radius: inherit;
    display: flex;
    height: 100%;
    justify-content: center;
    padding: 4px;
    padding-right: 0;
    width: 100%;
`

export const FavIcon = styled.img<{ $size: ControlSize }>`
    border-radius: ${({ $size }) => borderRadiusFromControlSize($size)}px;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
`
